import { FC } from "react";
import { Dialog } from "../../core/Dialog/Dialog";
import { useTranslation } from "react-i18next";

type AccountMismatchPopupProps = {
  onClose: () => void;
  isOpen: boolean;
};

const AccountMismatchPopup: FC<AccountMismatchPopupProps> = (props) => {
  const { onClose, isOpen } = props;
  const { t } = useTranslation();

  return (
    <Dialog
      open={isOpen}
      title={t("Payment_Account Mismatch")}
      description={t(
        "Payment_The account you are trying to subscribe does not match the account currently logged in. Please log out and log in with the correct account to continue.",
      )}
      mainAction={{
        id: "close-dialog",
        text: t("Payment_Ok"),
        onClick: onClose,
        "data-gamepad": "default-selected",
      }}
    />
  );
};

export default AccountMismatchPopup;
